exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input#message {\n  background: #fff;\n  border: none;\n  outline: none;\n  box-shadow: none;\n  font-size: 1.6em;\n  font-weight: 300;\n  margin-bottom: 3em;\n  padding: 1.2em .7em; }\n\n#details-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  width: 100%; }\n\n#details-container p {\n  background: #fff;\n  padding: 1.4em;\n  color: #696969;\n  margin: 12px;\n  width: auto;\n  min-width: 200px; }\n\nimg {\n  display: block;\n  margin-bottom: 12px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/bishop.duperret.GOMURAL/Documents/ConciergeDashboard/gomural-mural-outlook-configuration-dashboard-43c2b5785cd3/src/app/app.component.scss
// module id = ../../../../../src/app/app.component.scss
// module chunks = 24